import React from 'react';
import {
  Box,
  Chip,
  Avatar,
  useTheme,
  Tooltip,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAuth } from '../../../context/AuthContext';
import OrbitLogo from '../../common/OrbitLogo';
import { useNavigate } from 'react-router-dom';

const HeaderContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(3.7),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  position: 'relative',
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  marginBottom: theme.spacing(0.5),
}));


const StatusIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: isActive ? theme.palette.success.main : theme.palette.grey[400],
  border: `2px solid ${theme.palette.background.paper}`,
}));

export default function DrawerHeader() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <HeaderContainer>
      <StatusIndicator isActive={user?.is_active} />
      
      {/* Logo */}
      <LogoContainer 
        onClick={() => (navigate("/"))}
        sx={{
          cursor: "pointer",
        }}
      >
        <OrbitLogo height={32} />
      </LogoContainer>
    </HeaderContainer>
  );
}